import { gql } from '@apollo/client';
export const SEARCH_SHARERS = gql`
    query SearchSharers($search: String!, $datasetId: Int!) {
        searchSharers(searchTerm: $search, datasetId: $datasetId) {
            id
            name
        }
    }
`;
//1
export const GET_SHARERS = gql`
    query GetSharers($userIds: [Int]!, $groupIds: [ID]!) {
        getSharers(userIds: $userIds, groupIds: $groupIds) {
            id
            name
        }
    }
`;

export const UPDATE_FIXTURE_VISIBILITY = gql`
    mutation UpdateFixtureVisibility(
        $id: ID!
        $userIds: [Int]!
        $groupIds: [ID]!
    ) {
        updateFixtureVisibility(
            id: $id
            userIds: $userIds
            groupIds: $groupIds
        ) {
            id
            visibility {
                groupIds
                userIds
            }
            groupOnlyExpiryDate
            lastUpdatedDateTimeByUser
            lastUpdatedByUser {
                username
                fullName
            }
        }
    }
`;

export const UPDATE_ORDER_VISIBILITY = gql`
    mutation UpdateOrderVisibility(
        $id: ID!
        $userIds: [Int]!
        $groupIds: [ID]!
    ) {
        updateOrderVisibility(id: $id, userIds: $userIds, groupIds: $groupIds) {
            id
            visibility {
                groupIds
                userIds
            }
            groupOnlyExpiryDate
            lastUpdatedDateTimeByUser
            lastUpdatedByUser {
                username
                fullName
            }
        }
    }
`;
